<template>
  <div class="modelos">
    <select @change="modeloSeleccionado" v-model="modelo" :name="id" :id="id">
      <option value="">Seleccione...</option>
      <option v-for="item in modelos" :value="item">{{item.nombre | upper}}</option>
    </select>
  </div>
</template>

<script>
  export default {
    name: "ModeloVehiculo",
    props: ["index", "modelos", "id"],
    methods: {
      modeloSeleccionado() {
        this.$emit("modeloSeleccionado", {index: this.index, value: this.modelo})
        this.$store.dispatch("producto/getVehiculos", {index: this.index})
      }
    },
    computed: {
      modelo: {
        get() {
          return this.$store.state.producto.producto.vehiculosCompatibles[this.index].modelo
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_VEHICULO_COMPATIBLE", {
            key: "modelo",
            index: this.index,
            data: value
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .modelos {
    select {
      width: 100%;
    }
  }
</style>
